<template>

  <nav class="bg-black shadow-lg sticky top-0 z-10">
    <div class="container w-full mx-auto px-3 md:px-0">

      <div class="w-full py-3 grid grid-cols-3 text-white font-semibold uppercase text-sm md:px-2">
        
        <div class="flex items-center justify-start font-semibold uppercase col-span-2 md:col-span-1">
          <font-awesome-icon :icon="['fab', 'elementor']" class="text-2xl mr-2 hidden md:inline-block" />
          <font-awesome-icon :icon="['fas', 'bars']" class="text-2xl mr-2 inline-block md:hidden cursor-pointer" @click="isOpen = !isOpen"/>
          <p class="truncate w-7/12" v-if="evento">{{evento.descripcion}}</p>
        </div>

        <div class="hidden md:flex items-center justify-center md:text-center">
          <router-link to="/empresa" class="rounded-md px-3 py-2 text-white hover:bg-gray-700 hover:text-white ">
            <font-awesome-icon :icon="['far', 'building']" class="mr-1" />
            Empresa
          </router-link>
<!--          <router-link to="/productos" class="rounded-md px-3 py-2 text-white hover:bg-gray-700 hover:text-white" v-if="empresa && empresa.expositor">
            <font-awesome-icon :icon="['fas', 'box']" class="mr-1 " />
            Productos
          </router-link>-->
          <router-link to="/invitaciones" class="rounded-md px-3 py-2  text-white hover:bg-gray-700 hover:text-white">
            <font-awesome-icon :icon="['fas', 'ticket']" class="mr-1" />
            Acreditados
          </router-link>
        </div>

        
        <div class="relative flex items-center justify-end">
          <button @click="isUserOpen = !isUserOpen" class="rounded-md px-3 py-2 text-white hover:bg-gray-700 z-50">
            <font-awesome-icon :icon="['far', 'user']"/>
            <span class="hidden md:inline-block uppercase md:mx-1" v-if="usuarioEmpresa">{{usuarioEmpresa.nombreCompleto}}</span>
            <font-awesome-icon :icon="['fas', 'chevron-down']" v-if="!isUserOpen" />
            <font-awesome-icon :icon="['fas', 'chevron-up']" v-if="isUserOpen" />
          </button>

          <div v-if="isUserOpen" class="fixed inset-0 bg-transparent z-40" @click="isUserOpen = false"></div>

          <div v-if="isUserOpen" class="absolute right-0  z-50 font-normal" :class="{ 'mt-44': empresa.expositor, 'mt-32': !empresa.expositor }">
            <div class="w-60 bg-gray-600 rounded-md shadow-lg">
              <router-link to="/perfil" class="block rounded-t-md px-4 py-2 text-white hover:bg-gray-700">
                <font-awesome-icon :icon="['far', 'user']" />
                Mi Perfil
              </router-link>
              <a v-if="empresa.expositor" :href="'https://cloud.qreventos.com/empresas/catalogoMarco/' + evento.id" target="catalogo" class="block rounded-b-md px-4 py-2 text-white hover:bg-gray-700 cursor-pointer">
                <font-awesome-icon :icon="['far', 'circle-right']" />
                Ver catálogo
              </a>
              <a v-if="empresa.expositor" :href="'https://cloud.qreventos.com/empresas/catalogo/' + evento.id" target="catalogo" class="block rounded-b-md px-4 py-2 text-white hover:bg-gray-700 cursor-pointer">
                <font-awesome-icon :icon="['far', 'circle']" />
                Catálogo sin marco
              </a>
              <a @click="logout" class="block rounded-b-md px-4 py-2 text-white hover:bg-gray-700 cursor-pointer">
                <font-awesome-icon :icon="['fas', 'right-from-bracket']" />
                Cerrar sesión
              </a>
            </div>
          </div>
        </div>



      </div>

    </div>

    <!-- Menú dropdown mobile -->
    <div v-if="isOpen" class="md:hidden text-white font-semibold uppercase text-sm z-60">
      <div class="h-[1px] bg-gray-500 w-full"></div>
      <div class="flex flex-col px-2 py-2">
        <router-link to="/empresa" class="rounded-md px-3 py-2 text-white hover:bg-gray-700">
          <font-awesome-icon :icon="['far', 'building']" class="mr-1" />
          Empresa
        </router-link>
        <router-link to="/productos" class="rounded-md px-3 py-2 text-white hover:bg-gray-700">
          <font-awesome-icon :icon="['fas', 'box']" class="mr-1" />
          Productos
        </router-link>
        <router-link to="/invitaciones" class="rounded-md px-3 py-2 text-white hover:bg-gray-700">
          <font-awesome-icon :icon="['fas', 'ticket']" class="mr-1" />
          Invitaciones
        </router-link>
      </div>
    </div>

    <div class="h-[1px] bg-gray-500 w-full"></div>

  </nav>


</template>

<script lang="ts">
import { defineComponent } from 'vue';
import Swal from 'sweetalert2'

import suiteConfig from '@/services/suite.config';
import seguridadServices from '@/services/seguridad.services';
import eventoServices from 'qreventos-suite/eventos';

import empresaService, { Empresa, UsuarioEmpresa } from 'qreventos-suite/empresas';
import {  Evento } from 'qreventos-suite/services';

export default defineComponent({  
  data() {
    return {
      isOpen: false,    
      isUserOpen: false,
      usuarioEmpresa: undefined as unknown as UsuarioEmpresa,
      empresa: undefined as unknown as Empresa,
      evento: undefined as unknown as Evento
    }
  },
  methods: {
    async logout() {
      this.isUserOpen = false;

      Swal.fire({
        title: '¡Atención!',
        html: `¿Desea salir del sistema?`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: 'green',
        confirmButtonText: 'SI, SALIR!',
        cancelButtonText: 'CANCELAR',
        buttonsStyling: true
      }).then((isConfirm) => {
        if (isConfirm.value === true) {  
          seguridadServices.logout();
          this.$router.push({ path: '/' });
        }
      });
    },
    async fillDatos() {
      try {
        this.usuarioEmpresa = seguridadServices.getLocalUsuarioEmpresa() as UsuarioEmpresa;
        this.evento = await eventoServices.validarEvento(this.usuarioEmpresa.evento.id);  
        this.empresa = await empresaService.findEmpresaBy(this.usuarioEmpresa.evento.id, this.usuarioEmpresa.empresa.id) as Empresa;

      } catch(error) {
        Swal.fire({ title: "Error", text: error + '', icon: "error" })
          .then(() => {
            seguridadServices.logout();
            this.$router.push({ path: '/' });
          });
      }
    },
  },     
  async mounted() {
    eventoServices.clientId = suiteConfig.clientId;
    eventoServices.token = suiteConfig.token;

    this.fillDatos();

  },
});
</script>